let isProd = true;

let prod = "/api";
let dev = "http://back.citgroup.cn";

let base = isProd ? prod : dev;

base = dev;
export default {
    amap:"988b262540ae65a710f18bf4516193de",
    //首页
    homePage:{
        msgList:`${base}/productSystemApi/selectProductAndChildsForPortal`,
        listmsg:`${base}/productSystemApi/selectSubDescriptionAndCharacteristicsForPortal`,
        // msgList:`${base}/`,
        // listmsg:`${base}/productSystemApi/selectSubDescriptionAndCharacteristicsForPortal`,
        // navlist:`${base}/navlist.js`
    },
	//公司动态
    companyPage:{
      //新闻动态
      newsList:`${base}/productSystemApi/mobile`,
      //行业研究
      industryList:`${base}/productSystemApi/mobile`,
      //列表详情页
      newsDetail:`${base}/productSystemApi/findById2`,
    },
  //案例成果
   caseResults:{
      //成果列表
     caseList:`${base}/productSystemApi/mobile`,
     //成果详情


    //  caseDetail:`${base}/caseDetail.js`

     caseDetail:`${base}/productSystemApi/findById2`

   },
  //演示系统
  demoSystem:{
    //演示系统列表
    demoList:`${base}/productSystemApi/custmobile`
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/config.js